<div class="ds-progress-bar">
  <div class="line" [ngClass]="type" [style.width.%]="percentage ?? 5"></div>
</div>
